module.exports = __webpack_public_path__ + "img/l_sa.0808056e.png";